import DOMPurify from 'isomorphic-dompurify';

export function sanitizeHtml(dirty: string): string {
    return DOMPurify.sanitize(dirty);
}
